const actionTypeIdentifier = 'F910B160-11D0-4C88-8D6E-1'; // to be updated

//location form actions
export const resetWirelineOtherRequestForm = `RESET-WIRELINE-OTHER-REQUEST-FORM-${actionTypeIdentifier}`;
export const setSubscriptionDetails = `SET-WIRELINE-OTHER-REQUEST-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setOtherRequestOptions = `SET-WIRELINE-OTHER-REQUEST-OTHER-OPTIONS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELINE-OTHER-REQUEST-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setResetLoading = `SET-WIRELINE-OTHER-RESET-LOADING-${actionTypeIdentifier}`;
export const setResetApprover = `SET-WIRELINE-OTHER-REQUEST-RESET-APPROVER-${actionTypeIdentifier}`;


export const wirelineOtherRequestModel = {
    circuitCode: ''
    , circuitId: 0
    
    , otherRequestTypeId: ''
    , vendorDetailId: 0
    , employeeEmail: ''
    , wireLineApproverId: 0

    , localContactEmail: ''
    , localContactFullName: ''
    , localContactPhone: ''

    , altLocalContactEmail: ''
    , altLocalContactFullName: ''
    , altLocalContactPhone: ''

    , expediteRequest: false
    , businessJustification: ''
    , additionalInformation: ''
}
